import React from 'react'
import { prop } from 'ramda'
import PropTypes from 'prop-types'
import { lifecycle } from 'recompose'
import ContentBoxWithoutHeader from '../../../layout/component/ContentBoxWithoutHeader'
import ContentBoxHeader from '../../../layout/component/ContentBoxHeader'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import ContentBoxBody from '../../../layout/component/ContentBoxBody'
import { BACKEND_URL } from '../../../../util/api'
import { DEFINED_IMAGE_LIST, MAX_IMAGE_SIZE } from '../../state/detail/const'
import Dropzone from 'react-dropzone'

const moment = require('moment')
const ROTATE_CSS = {
    0: 'rotate-0',
    90: 'rotate-90',
    180: 'rotate-180',
    270: 'rotate-270',
}

const UploadingImageMask = () => {
    return (
        <div className="uploading-image-mask">
            <svg
                version="1.1"
                id="loader-1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="80%"
                height="80%"
                viewBox="0 0 50 50"
                xmlSpace="preserve"
            >
                <path
                    fill="#3498db"
                    d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
                >
                    <animateTransform
                        attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 25 25"
                        to="360 25 25"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </path>
            </svg>
        </div>
    )
}

const ImageUploadDiv = ({
    image,
    versionImageList,
    customerId,
    uploadingImages,
    retryImages,
    retryUploadFromLocalStorage,
    uploadCustomerImage,
}) => {
    if (versionImageList) {
        versionImageList.sort((a, b) => {
            a = a.lastModified
            b = b.lastModified
            if (!a && !b) {
                return 0
            }
            if (!a && b) {
                return -1
            }
            if (a && !b) {
                return 1
            }
            return moment(b).unix() - moment(a).unix()
        })
    }

    const ImageShown = () => {
        const versionImage = versionImageList && versionImageList[0]
        const rotate =
            versionImage && versionImage.meta && versionImage.meta.rotate
                ? versionImage.meta.rotate
                : 0

        return versionImageList ? (
            <div
                className={`image-upload-div ${ROTATE_CSS[rotate]}`}
                style={{
                    backgroundImage: `url(${BACKEND_URL +
                        versionImageList[0].link})`,
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                }}
            ></div>
        ) : (
            <div className="image-upload-div">
                <img
                    src={image.defaultImage}
                    width="100%"
                    height="auto"
                    alt="alt"
                />
            </div>
        )
    }
    const PlusIcon = () => {
        return <div className="plus-icon-upload-image">+</div>
    }
    const isCurrentImageUploading = uploadingImages[image.name] === true
    const shouldRetryImage =
        retryImages[image.name] === true || localStorage.getItem(customerId + '-' + image.name + '-img') !== null

    const retryUploadClass = shouldRetryImage ? 'retry-upload' : '';

    const RetryButton = () => {
        return shouldRetryImage ? (
            <div>
                <p>Image upload failed.</p>
                <a onClick={() => retryUploadFromLocalStorage(image.name, customerId)}>
                    <i className="fa fa-refresh"></i>&nbsp;Retry
                </a>
            </div>
        ) : null
    }

    return (
        <div className={retryUploadClass}>
            <Dropzone
                multiple={false}
                accept='image/*'
                maxSize={MAX_IMAGE_SIZE}
                className='image-upload-dropzone'
                disablePreview={true}
                onDrop={fileList => {
                    uploadCustomerImage(fileList, image.name, customerId)
                }}
            >
                {isCurrentImageUploading && <UploadingImageMask />}
                <PlusIcon />
                <ImageShown />
                <p>{image.shortTitle}</p>
            </Dropzone>
            <RetryButton />
        </div>
    )
}

const ImageUpload = ({
    canSeeImages,
    imageVersionList,
    uploadCustomerImage,
    retryUploadFromLocalStorage,
    customerId,
    skipImages = [],
    uploadingImages,
    retryImages,
}) => {
    if (!canSeeImages) {
        return null
    }
    return (
        <ContentBoxWithoutHeader>
            <ContentBoxHeader>
                <Row>
                    <Column size={8}>
                        <h1>Upload Photos</h1>
                        <p>
                            Click on the photo to take a picture or uploading
                            from camera roll. In case the image is not good
                            enough (blurry, wrong rotation, wrong angle), please
                            click again on the photo and repeat.
                        </p>
                    </Column>
                </Row>
            </ContentBoxHeader>
            <ContentBoxBody>
                <div className="image-upload-grid">
                    {
                        DEFINED_IMAGE_LIST.map((image, index) => {
                            if (skipImages.includes(image.name)) {
                                return null
                            }
                            return (
                                <ImageUploadDiv
                                    key={index}
                                    image={image}
                                    customerId={customerId}
                                    uploadCustomerImage={uploadCustomerImage}
                                    uploadingImages={uploadingImages}
                                    retryUploadFromLocalStorage={retryUploadFromLocalStorage}
                                    retryImages={retryImages}
                                    versionImageList={
                                        imageVersionList[image.name]
                                    }
                                />
                            )
                        })}
                </div>
            </ContentBoxBody>
        </ContentBoxWithoutHeader>
    )
}

ImageUpload.propTypes = {
    uploadingImages: PropTypes.object,
    customerId: PropTypes.string,
    findImageVersion: PropTypes.func.isRequired,
    uploadCustomerImage: PropTypes.func.isRequired,
    canSeeImages: PropTypes.bool.isRequired,
    imageVersionList: PropTypes.object,
    skipImages: PropTypes.arrayOf(
        PropTypes.oneOf(DEFINED_IMAGE_LIST.map(prop('name')))
    ),
}

export default lifecycle({
    componentDidMount () {
        this.props.findImageVersion(this.props.customerId)
    },
})(ImageUpload)



// WEBPACK FOOTER //
// ./src/modules/customer/component/imageUpload/ImageUpload.js